// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + "87adc6e3" + ".chunk.js");